import { useWishlist } from '~/features/commerce-api/hooks/wishlist/useWishList';
import { usePDPData } from '~/features/product-details/context';
import { WishlistButton } from '~/shared/components/NewProductCard/components';

type Props = Omit<React.ComponentProps<typeof WishlistButton>, 'isActive' | 'onDebouncedClick'>;

/**
 * The favourite toggle, with its own data.
 *
 * `useWishlist` subscribes to both the customer store and the wishlist query, so whichever
 * component calls it re-renders whenever either moves - including on every toggle, which mutates
 * the list and refetches it. Owning that call here rather than in `ProductOverview` keeps the
 * re-render to this button instead of the whole overview and everything beneath it, the gallery
 * and the tabs included. It reads the product from context for the same reason: a prop would put
 * the coupling back.
 */
export const ProductWishlistButton: React.FC<Props> = (props) => {
    const { product } = usePDPData();
    const { handleFavourite, isFavorite } = useWishlist();

    return (
        <WishlistButton
            {...props}
            isActive={isFavorite(product.id)}
            onDebouncedClick={() => handleFavourite?.(product)}
        />
    );
};
